var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDistributorChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ECC0B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0781 11.6562L16.5781 8.11562C16.3938 8.04818 16.1969 8.00781 16 8C15.8 8.00781 15.6031 8.04427 15.4219 8.11458L6.92188 11.6562C6.36313 11.8906 6 12.4344 6 13.0406V23.5C6 23.7773 6.22266 24 6.5 24L8.5 24C8.77734 24 9 23.7773 9 23.5V16C9 15.4494 9.45688 15.0281 10.0197 15.0281H21.9822C22.5437 15 23 15.45 23 16V23.5C23 23.7773 23.2227 24 23.5 24L25.5 24C25.7773 24 26 23.7773 26 23.5V13.0406C26 12.4344 25.6375 11.8906 25.0781 11.6562Z",
    fill: "#E34B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 17H10.5C10.2281 17 10 17.2281 10 17.5V19.5C10 19.775 10.2281 20 10.5 20H15.5C15.7734 20 16 19.7734 16 19.5V17.5C16 17.2281 15.775 17 15.5 17ZM15.5 21H10.5C10.2281 21 10 21.2281 10 21.5V23.5C10 23.775 10.2281 24 10.5 24H15.5C15.7734 24 16 23.7734 16 23.5V21.5C16 21.2281 15.775 21 15.5 21ZM17.5 21H21.5C21.775 21 22 21.2281 22 21.5V23.5C22 23.7734 21.7734 24 21.5 24H17.5C17.2266 24 17 23.7734 17 23.5V21.5C17 21.2266 17.2266 21 17.5 21Z",
    fill: "#E34B31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributorChecked);
export default __webpack_public_path__ + "static/media/distributor-checked.0a2785b40c2288430a80d2f8d39a8802.svg";
export { ForwardRef as ReactComponent };